export abstract class OrbitControlConstraint {
  abstract check(camera, newPosition): boolean;

  dispose(): void {
  }
}



// WEBPACK FOOTER //
// ./src/app/classes/orbitControlConstraint/OrbitControlConstraint.ts